import { StoredSession } from './adsGenerator.types';

// The visitor's OTP session, kept in the browser until it expires (60 min,
// same as the backend token) so a refresh or a new tab still shows their ads.
// Storage can be blocked (private mode), so every access is guarded and the
// page simply falls back to an in-memory session.

const STORAGE_KEY = 'adsGeneratorSession';

const isValid = (value: unknown): value is StoredSession => {
  const session = value as StoredSession;
  return (
    !!session &&
    typeof session.phone === 'string' &&
    typeof session.sessionToken === 'string' &&
    typeof session.expiresAt === 'number'
  );
};

export const clearSession = (): void => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // storage unavailable
  }
};

export const saveSession = (session: StoredSession): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  } catch (e) {
    // storage unavailable
  }
};

// The saved session if it is still valid; an expired or broken one is removed.
export const loadSession = (): StoredSession | null => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const session: unknown = JSON.parse(raw);
    if (isValid(session) && session.expiresAt > Date.now()) {
      return session;
    }
  } catch (e) {
    // storage unavailable or unreadable
  }
  clearSession();
  return null;
};

const CLAIM_KEY = 'adsGeneratorClaim';
const CLAIM_TTL_MS = 24 * 60 * 60 * 1000;

export const clearClaim = (): void => {
  try {
    window.localStorage.removeItem(CLAIM_KEY);
  } catch (e) {
  }
};

export const saveClaim = (claimToken: string): void => {
  try {
    window.localStorage.setItem(CLAIM_KEY, JSON.stringify({ claimToken, savedAt: Date.now() }));
  } catch (e) {
  }
};

export const loadClaim = (): string | null => {
  try {
    const raw = window.localStorage.getItem(CLAIM_KEY);
    const saved = raw ? JSON.parse(raw) : null;
    if (saved && typeof saved.claimToken === 'string' && Date.now() - saved.savedAt < CLAIM_TTL_MS) {
      return saved.claimToken;
    }
  } catch (e) {
  }
  clearClaim();
  return null;
};
